import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { SuccessfullyApprovedAgreementComponent } from '../worker-agreements/successfully-approved-agreement/successfully-approved-agreement.component';
import { WorkerAgreementDetailsComponent } from '../worker-agreements/worker-agreement-details/worker-agreement-details.component';
import { WorkerAgreementsListComponent } from '../worker-agreements/worker-agreements-list/worker-agreements-list.component';
import { AgreementNotReadyComponent } from './agreement-not-ready/agreement-not-ready.component';
import { VoidAgreementModalComponent } from './worker-agreement-details/void-agreement-modal/void-agreement-modal.component';
import { ApproveAgreementVoidingComponent } from './approve-agreement-voiding/approve-agreement-voiding.component';
import { CustomControlsModule } from '../custom-controls/custom-controls.module';
import { SuccessfullySendToApprovalComponent } from './successfully-send-to-approval/successfully-send-to-approval.component';
import { WorkerAgreementTerminationModule } from '../worker-agreement-termination/worker-agreement-termination.module';
import { AgreementFormComponent } from './agreement-form/agreement-form.component';
import { AgreementPickerComponent } from './agreement-picker/agreement-picker.component';
import { MultipleAgreementFormComponent } from './multiple-agreement-form/multiple-agreement-form.component';
import { SendMultipleWorkerAgreementsToApprovalSignaturePadComponent } from './send-multiple-worker-agreements-to-approval-signature-pad/send-multiple-worker-agreements-to-approval-signature-pad.component';
import { VirtualScrollModule } from '../virtual-scroll/virtual-scroll.module';
import { WorkerAgreementListTabsContainerComponent } from './worker-agreement-list-tabs-container/worker-agreement-list-tabs-container.component';
import { EmploymentConditionsConfirmationModule } from '../employment-conditions-confirmation';
import { MandateAgreementWorkedDayListModule } from '../mandate-agreement-worked-day-list/mandate-agreement-worked-day-list.module';
import { ListFilterModule } from '../list-filter/list-filter.module';
import { AgreementAnnexModule } from './agreement-annex/agreement-annex.module';
import { AnnexDetailsComponent } from './annex-details/annex-details.component';
import { AnnexFilePanelComponent } from './annex-details/annex-file-panel.component/annex-file-panel.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SplitComponent } from '../split/components/split/split.component';
import { ResponsibilityMultiSelectComponent } from '../shared/components/responsibility-multi-select/responsibility-multi-select.component';
import { WorkerAgreementDetailsPanelComponent } from './worker-agreements-list/worker-agreement-details-panel/worker-agreement-details-panel.component';
import { AnnexesRegistryComponent } from './annexes-registry/annexes-registry.component';
import { AnnexDetailsPanelComponent } from './annexes-registry/annex-details-panel/annex-details-panel.component';

@NgModule({
  imports: [
    SharedModule,
    CustomControlsModule,
    WorkerAgreementTerminationModule,
    VirtualScrollModule,
    EmploymentConditionsConfirmationModule,
    MandateAgreementWorkedDayListModule,
    ListFilterModule,
    AgreementAnnexModule,
    SplitComponent,
    WorkerAgreementDetailsPanelComponent,
    PdfViewerModule,
  ],
  declarations: [
    AgreementFormComponent,
    WorkerAgreementDetailsComponent,
    WorkerAgreementsListComponent,
    AgreementNotReadyComponent,
    VoidAgreementModalComponent,
    ApproveAgreementVoidingComponent,
    SuccessfullySendToApprovalComponent,
    SuccessfullyApprovedAgreementComponent,
    AgreementPickerComponent,
    MultipleAgreementFormComponent,
    SendMultipleWorkerAgreementsToApprovalSignaturePadComponent,
    WorkerAgreementListTabsContainerComponent,
    AnnexDetailsComponent,
    AnnexFilePanelComponent,
    AnnexesRegistryComponent,
    AnnexDetailsPanelComponent,
  ],
  exports: [AgreementNotReadyComponent, AgreementPickerComponent],
})
export class WorkerAgreementsModule {}
